export default {
  assignoperators: {
    title: "Назначение операторов для разноски пачек",
    topRow: {
      userCode: "Оператор",
      worked: "работавший",
      onPositions: "на должности"
    },
    receipts: {
      modal: {
        title: "Информация о пачке"
      },
      form: {
        summa: {
          title: "Cумма"
        },
        datebank: {
          title: "Дата по банку"
        },
        quantity: {
          title: "Квитанций"
        },
        countband: {
          title: "Бандеролей"
        },
        reasonname: {
          title: "Причина возврата"
        }
      }
    },
    freePacksColumn: {
      headers: {
        freePacks: "Свободные пачки"
      }
    },
    assignedPacksColumn: {
      headers: {
        assignedPacks: "Пачки, закрепленные за оператором"
      }
    },
    packsCountbandColumn: {
      headers: {
        packsCountband: "Бандероли"
      }
    },
    packsQuantityColumn: {
      headers: {
        packsQuantity: "Квитанции"
      }
    },
    operatorForm: {
      userCode: {
        msg: "Пачки, закрепленные за оператором"
      }
    },
    statusInfoPack: {
      pack: "Пачка",
      wasPosting: "была разнесена",
      title: "Успешно"
    },
    assignBtn: {
      confirm: {
        assignOperator: "Назначить оператора",
        toWorkWithPack: "для работы с этой пачкой",
        title: "Назначение"
      }
    },
    unassignBtn: {
      confirm: {
        unassignOperator: "Освободить оператора",
        fromWorkWithPack: "от работы с этой пачкой",
        title: "Освобождение"
      }
    }
  }
};
